<template>
  <section class="content">
    <div class="center-block row">
      <div class="align-center col-xs-12 flex m-b-10 p-x-0">
        <router-link
          :to="{
            'name': goBackInfo.name,
            'params': goBackInfo.params,
            'query': goBackInfo.query
          }"
        >
          <div class="btn btn-default flex m-r-5">
            <span>返回</span>

            <span v-text="goBackInfo.title" />

            <span v-text="goBackInfo.subtitle" />
          </div>
        </router-link>

        <div class="darken-1 flex grey">
          <div
            v-if="brand.name || store.brand_name"
            class="m-r-5"
            v-text="brand.name
              ? brand.name
              : store.brand_name
                ? store.brand_name
                : ''"
          />

          <div
            v-if="store.name"
            class="m-r-5"
            v-text="'/'"
          />

          <div
            v-if="store.name"
            v-text="store.name"
          />
        </div>
      </div>

      <div class="col-md-12">
        <CrBlock />
      </div>
    </div>
  </section>
</template>

<script>
import crBlock from './Temp/CrBlockTemp.vue'
import NdExtendHandleMenu from '@/extends/nd-extend-handle-menu.vue'

export default {
  name: 'UpMenuBlock',

  components: {
    CrBlock: crBlock
  },

  extends: NdExtendHandleMenu,

  computed: {
    getDataH () {
      return this.$parent.getDataH
    },

    checkInput () {
      return this.$parent.checkInput
    }
  },

  mounted () {
    this.getExtendHandleMenuInfo()
  }
}
</script>



// WEBPACK FOOTER //
// UpMenuBlock.vue?32ede41b